var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthicsLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Other/logo/colored/EthicsLine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "23.5906059%",
    y1: "86.1848122%",
    x2: "79.3721548%",
    y2: "12.5443973%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "49.1568917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/colored/EthicsLine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0074763,160.697838 C47.7256031,151.851942 28,126.229552 28,96 C28,58.444637 58.444637,28 96,28 C133.555363,28 164,58.444637 164,96 C164,126.229552 144.274397,151.851942 116.992524,160.697838 C116.83513,157.52452 114.212382,155 111,155 L102,155 L102,137 C102,134.387562 100.330385,132.165084 98,131.341411 L98,90 L127.980279,90 L117.420971,118 L117,118 C119.657135,122.206336 124.347759,125 129.690878,125 C135.030223,125 139.717993,122.210281 142.376125,118.008912 L142.420971,118 L130.907368,90 L140,90 C142.215389,90 142.78731,86.9328285 140.720799,86.1344037 L98,69.6286407 L98,61.6585886 C100.330385,60.8349158 102,58.6124377 102,56 C102,52.6862915 99.3137085,50 96,50 C92.6862915,50 90,52.6862915 90,56 C90,58.6124377 91.6696153,60.8349158 94,61.6585886 L94,69.6286407 L51.2792014,86.1344037 C49.2126903,86.9328285 49.7846106,90 52,90 L61.5593079,90 L51,118 L50.5790286,118 C53.236164,122.206336 57.9267878,125 63.2699068,125 C68.6092511,125 73.2970218,122.210281 75.955154,118.008912 L76,118 L64.4863965,90 L94,90 L94,131.341411 C91.6696153,132.165084 90,134.387562 90,137 L90,155 L81,155 C77.7876184,155 75.1648699,157.52452 75.0074763,160.697838 Z M94,73.9168139 L94,86 L62.7258713,86 L94,73.9168139 Z M98,86 L98,73.9168139 L129.274129,86 L98,86 Z M96,59 C94.3431458,59 93,57.6568542 93,56 C93,54.3431458 94.3431458,53 96,53 C97.6568542,53 99,54.3431458 99,56 C99,57.6568542 97.6568542,59 96,59 Z M53.0695215,118 L63.0404223,91.7130798 L73.9177686,118 L53.0695215,118 Z M119.490493,118 L129.461394,91.7130798 L140.33874,118 L119.490493,118 Z",
    id: "Logo",
    fill: "url(#linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthicsLine);
export default __webpack_public_path__ + "2927e97745b788f5f115af8c87ace7bb.svg";
export { ForwardRef as ReactComponent };